import { useEffect } from "react";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { DemandCompanies } from "@/components/demand/DemandCompanies";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const DemandCompaniesPage = () => {
  useSetTitle({
    title: "Demand",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.DEMAND);
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Demand</TopbarTitle>
      </TopbarContainer>
      <Column className="flex-1 overflow-y-auto p-6">
        <DemandCompanies />
      </Column>
    </Column>
  );
};
